import { CheckCircle2, ShieldCheck, TimerReset, Wallet } from 'lucide-react';

import { MetricCard } from '@/components/MetricCard';
import { formatLatency } from '@/lib/format';

export function StatsStrip({
  avgLatency,
  statuses,
  vendors,
  routes,
}: {
  avgLatency: number | null;
  statuses: number;
  vendors: number;
  routes: number;
}) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      <MetricCard label="Средняя latency" value={formatLatency(avgLatency)} icon={<TimerReset className="h-3.5 w-3.5" />} />
      <MetricCard label="Статусов" value={String(statuses)} icon={<ShieldCheck className="h-3.5 w-3.5" />} />
      <MetricCard label="Вендоров" value={String(vendors)} icon={<Wallet className="h-3.5 w-3.5" />} />
      <MetricCard label="Найдено маршрутов" value={String(routes)} icon={<CheckCircle2 className="h-3.5 w-3.5" />} />
    </div>
  );
}
